import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import OutgoingOrderRow from './OrderRow';

interface OutgoingOrdersTableProps {
  orders: any[];
}

const OrdersTable: React.FC<OutgoingOrdersTableProps> = ({ orders }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Order ID</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Total Price</TableCell>
            <TableCell>Items</TableCell>
            <TableCell>Quantity</TableCell>
            <TableCell>Fulfillment Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.map((order) => (
            <OutgoingOrderRow key={order.id} order={order} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrdersTable;
